export default function CardSkeleton({ count = 6, poster = false }: { count?: number; poster?: boolean }) {
  return (
    <div className={`grid grid-cols-1 gap-6 sm:grid-cols-2 ${poster ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className={`w-full animate-pulse bg-background-200 ${poster ? "aspect-[2/3]" : "h-44"}`}></div>
          <div className="space-y-3 p-4">
            <div className="h-4 w-3/4 animate-pulse rounded bg-background-200"></div>
            <div className="h-3 w-full animate-pulse rounded bg-background-100"></div>
            <div className="h-3 w-2/3 animate-pulse rounded bg-background-100"></div>
          </div>
        </div>
      ))}
    </div>
  );
}